import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import UpdateJobsContainer from './Components/UpdateJobsContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';

const UpdateJobsMain = () => (
  <PageContainer pageName="update-jobs">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_UPDATE_JOBS}>
      <UpdateJobsContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default UpdateJobsMain;
